var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentBlockItem1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 412,
    viewBox: "0 0 379 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 378.667,
    height: 412,
    rx: 30,
    fill: "#0A021A",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 376.667,
    height: 410,
    rx: 29,
    stroke: "url(#paint0_linear_1510_26304)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1510_26304",
    x1: 362.38,
    y1: -6.99998,
    x2: 16.252,
    y2: 431.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7509E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#403E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403E46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentBlockItem1);
export default __webpack_public_path__ + "static/media/ContentBlockItem1.f90865c40d275006e3c64ea49c96e5c2.svg";
export { ForwardRef as ReactComponent };